"use client";

import {
  RedesignButton,
  type RedesignButtonProps,
} from "@/components/redesign/RedesignButton";
import { useAnchorClickHandler } from "@/hooks/useAnchorClickHandler";
import { useBlockAnchorsEnabled } from "@/puck/blockAnchors";

type BookDemoButtonProps = Omit<RedesignButtonProps, "onClick">;

/**
 * CTA button for builder blocks that smooth-scrolls to in-page anchors instead
 * of hard-jumping through the URL hash. Buttons whose link isn't an in-page
 * anchor — or pages without a matching target — fall back to normal navigation.
 * Where block anchors are suppressed (Studio block catalog), anchor links
 * render as plain buttons so they don't point at ids that don't exist.
 */
export function BookDemoButton({
  href = "#book-demo",
  ...rest
}: Readonly<BookDemoButtonProps>) {
  const anchorsEnabled = useBlockAnchorsEnabled();
  const handleAnchorClick = useAnchorClickHandler(href);

  if (href.startsWith("#") && !anchorsEnabled) {
    return <RedesignButton {...rest} />;
  }

  return <RedesignButton {...rest} href={href} onClick={handleAnchorClick} />;
}
